import api from "./core";

const basePath = "api/core/PatientContacts";

export default {
  get(patientId) {
    return api.post(`${basePath}/${patientId}`);
  },
  filter(filter, extraHeaders = {}) {
    return api.post(`${basePath}/Filter`, filter, extraHeaders);
  },
  create(data, extraHeaders = {}) {
    return api.put(`${basePath}`, data, extraHeaders);
  }
};
